import Track1 from "../../assets/AllTimesVinyl/alltimesvinyl1.png";
import Track2 from "../../assets/AllTimesVinyl/alltimesvinyl2.png";
import Track3 from "../../assets/AllTimesVinyl/alltimesvinyl3.png";
import Track4 from "../../assets/AllTimesVinyl/alltimesvinyl4.png";
import Track5 from "../../assets/AllTimesVinyl/alltimesvinyl5.png";
import Track6 from "../../assets/AllTimesVinyl/alltimesvinyl6.png";
// import Track7 from "../../assets/AllTimesVinyl/alltimesvinyl7.png"
// import Track8 from "../../assets/AllTimesVinyl/alltimesvinyl8.png"
// import Track9 from "../../assets/AllTimesVinyl/alltimesvinyl9.png"
import Track10 from "../../assets/AllTimesVinyl/alltimesvinyl10.png";
import Track11 from "../../assets/AllTimesVinyl/alltimesvinyl11.png";
import Track12 from "../../assets/AllTimesVinyl/alltimesvinyl12.png";
import Track13 from "../../assets/AllTimesVinyl/alltimesvinyl13.png";
import Track14 from "../../assets/AllTimesVinyl/alltimesvinyl14.png";
import Track15 from "../../assets/AllTimesVinyl/alltimesvinyl15.png";
import Track16 from "../../assets/AllTimesVinyl/alltimesvinyl16.png";
import Track17 from "../../assets/AllTimesVinyl/alltimesvinyl17.png";
import Track18 from "../../assets/AllTimesVinyl/alltimesvinyl18.png";
import Track19 from "../../assets/AllTimesVinyl/alltimesvinyl19.png";
import Track20 from "../../assets/AllTimesVinyl/alltimesvinyl20.png";
import Track21 from "../../assets/AllTimesVinyl/alltimesvinyl21.png";
const AllTimesVinylData = [
  {
    id: "1",
    img: Track1,
    title: "Essential Chicago Blues",
    artist: "Various Artists",
    price: "42",
    category: "ALL TIME CLASSICS Vinyl",
  },
  {
    id: "2",
    img: Track2,
    title: "Essential Detroit Blues",
    artist: "Various Artists",
    price: "42",
    category: "ALL TIME CLASSICS Vinyl",
  },
  {
    id: "3",
    img: Track3,
    title: "Music That Inspired Buena Vista Club",
    artist: "Various Artists",
    price: "63",
    category: "ALL TIME CLASSICS Vinyl",
  },
  {
    id: "4",
    img: Track4,
    title: "Stand By Me (OST)",
    artist: "Various Artists",
    price: "49",
    category: "ALL TIME CLASSICS Vinyl",
  },
  {
    id: "5",
    img: Track5,
    title: "The Very Best Of Jazz Instrumentals",
    artist: "Various Artists",
    price: "63",
    category: "ALL TIME CLASSICS Vinyl",
  },
  {
    id: "6",
    img: Track6,
    title: "Dirty Dancing Original Soundtrack",
    artist: "Various Artists",
    price: "50",
    category: "ALL TIME CLASSICS Vinyl",
  },
  // {
  //     id: "7",
  //     img: Track7,
  //     title: "Bad",
  //     artist: "Michael Jackson",
  //     price: "55",
  //     category: "ALL TIME CLASSICS Vinyl",
  // },
  // {
  //     id: "8",
  //     img: Track8,
  //     title: "Dangerous",
  //     artist: "Michael Jackson",
  //     price: "57",
  //     category: "ALL TIME CLASSICS Vinyl",
  // },
  // {
  //     id: "9",
  //     img: Track9,
  //     title: "HIstory Continues",
  //     artist: "Michael Jackson",
  //     price: "82",
  //     category: "ALL TIME CLASSICS Vinyl",
  // },
  {
    id: "10",
    img: Track10,
    title: "Rocketman (Music From The Motion Picture)",
    artist: "Elton John, Taron Egerton, Various Artists",
    price: "62",
    category: "ALL TIME CLASSICS Vinyl",
  },
  {
    id: "11",
    img: Track11,
    title: "Mamma Mia! Here We Go Again (The Movie Soundtrack Featuring The Songs Of ABBA)",
    artist: "Various Artists",
    price: "62",
    category: "ALL TIME CLASSICS Vinyl",
  },
  {
    id: "12",
    img: Track12,
    title: "Relaxing Piano",
    artist: "Various Artists",
    price: "62",
    category: "ALL TIME CLASSICS Vinyl",
  },
  {
    id: "13",
    img: Track13,
    title: "Classical Chillout",
    artist: "Various Artists",
    price: "62",
    category: "ALL TIME CLASSICS Vinyl",
  },
  {
    id: "14",
    img: Track14,
    title: "Calm Classical",
    artist: "Various Artists",
    price: "62",
    category: "ALL TIME CLASSICS Vinyl",
  },
  {
    id: "15",
    img: Track15,
    title: "Calm Christmas",
   artist: "Various Artists",
    price: "62",
    category: "ALL TIME CLASSICS Vinyl",
  },
  {
    id: "16",
    img: Track16,
    title: "The Best Of Franz Schubert",
    artist: "Various Artists",
    price: "62",
    category: "ALL TIME CLASSICS Vinyl",
  },
  {
    id: "17",
    img: Track17,
    title: "The Best Of Antonio Vivaldi",
    artist: "Various Artists",
    price: "62",
    category: "ALL TIME CLASSICS Vinyl",
  },
  {
    id: "18",
    img: Track18,
    title: "Intense Tchaikovsky",
    artist: "Various Artists",
    price: "62",
    category: "ALL TIME CLASSICS Vinyl",
  },
  {
    id: "19",
    img: Track19,
    title: "Sergei Rachmaninov: The Last Romantic Hero",
    artist: "Various Artists",
    price: "70",
    category: "ALL TIME CLASSICS Vinyl",
  },
  {
    id: "20",
    img: Track20,
    title: "The Greatest Showman (Original Motion Picture Soundtrack)",
    artist: "Various Artists",
    price: "62",
    category: "ALL TIME CLASSICS Vinyl",
  },
  {
    id: "21",
    img: Track21,
    title: "Essential Blues Anthology",
    artist: "Various Artists",
    price: "63",
    category: "ALL TIME CLASSICS Vinyl",
  },
];
export default AllTimesVinylData;
